import React, { useEffect, useState } from "react";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import { toast } from "react-toastify";
import httpService from "../../services/httpService";

export default function PromoCodeForm(props) {
  const id = props.match.params.id;
  const isNew = id === "new";

  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [type, setType] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [description, setDescription] = useState("");
  const [startDate, setStartDate] = useState(isNew ? new Date().toISOString().split("T")[0] : "");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(!isNew);

  useEffect(() => {
    if (!isNew) {
      httpService.get(`promocodes/${id}`).then(({ data }) => {
        setName(data.name || "");
        setCode(data.code || "");
        setType(data.type);
        setDiscount(data.discount);
        setDescription(data.description || "");
        setStartDate(formatDateForInput(data.dateTimeRange?.start));
        setEndDate(formatDateForInput(data.dateTimeRange?.end));
        setLoading(false);
      });
    }
  }, [id, isNew]);

  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toISOString().split("T")[0];
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      name,
      code,
      type: parseInt(type),
      discount: parseInt(discount),
      description,
      startDate,
      endDate,
    };

    const request = isNew
      ? httpService.post("promocodes", payload)
      : httpService.put(`promocodes/${id}`, payload);

    request
      .then(() => {
        toast.success(isNew ? "Promo code created" : "Promo code updated");
        props.history.push("/promocodes");
      })
      .catch((err) => {
        toast.error("Failed to save promo code");
      });
  };

  const handleDelete = () => {
    if (window.confirm("Are you sure you want to delete this promo code?")) {
      httpService
        .delete(`promocodes/${id}`)
        .then(() => {
          toast.success("Promo code deleted");
          props.history.push("/promocodes");
        })
        .catch(() => {
          toast.error("Failed to delete promo code");
        });
    }
  };

  if (loading) return <div className="container mt-3">Loading...</div>;

  return (
    <div className="container mt-3">
      <h2>{isNew ? "Create Promo Code" : "Edit Promo Code"}</h2>
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <Label for="name">Name</Label>
          <Input
            id="name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </FormGroup>
        <FormGroup>
          <Label for="code">Code</Label>
          <Input
            id="code"
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
          />
        </FormGroup>
        <FormGroup>
          <Label for="type">Type</Label>
          <Input
            id="type"
            type="select"
            value={type}
            onChange={(e) => setType(e.target.value)}
          >
            <option value={0}>Percent</option>
            <option value={1}>Amount</option>
          </Input>
        </FormGroup>
        <FormGroup>
          <Label for="discount">Discount</Label>
          <Input
            id="discount"
            type="number"
            value={discount}
            onChange={(e) => setDiscount(e.target.value)}
            required
          />
        </FormGroup>
        <FormGroup>
          <Label for="description">Description</Label>
          <Input
            id="description"
            type="textarea"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Label for="startDate">Start Date</Label>
          <Input
            id="startDate"
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            required
          />
        </FormGroup>
        <FormGroup>
          <Label for="endDate">End Date</Label>
          <Input
            id="endDate"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            required
          />
        </FormGroup>
        <div className="d-flex gap-2">
          <Button color="primary" type="submit">
            {isNew ? "Create" : "Update"}
          </Button>
          {!isNew && (
            <Button color="danger" type="button" onClick={handleDelete}>
              Delete
            </Button>
          )}
        </div>
      </Form>
    </div>
  );
}
